import { DesktopIcon, IPadIcon, IPadIconLandscape, IPhoneIcon, IPhoneIconLandscape } from '../../../../icons/Icons'

export enum IframeSizes {
  Desktop = 'desktop',
  SmallPhone = 'smallPhone',
  LargePhone = 'largePhone',
  LandscapeSmallPhone = 'landscapeSmallPhone',
  LandscapeLargePhone = 'landscapeLargePhone',
}

export const iframeSizeClasses: Record<IframeSizes, string> = {
  [IframeSizes.Desktop]: 'w-full h-[900px]',
  [IframeSizes.SmallPhone]: 'w-[375px] h-[667px]', // iPhone SE-like
  [IframeSizes.LargePhone]: 'w-[430px] h-[932px]', // iPhone 16 Pro Max-like
  [IframeSizes.LandscapeSmallPhone]: 'w-[667px] h-[375px]', // iPhone SE in landscape
  [IframeSizes.LandscapeLargePhone]: 'w-[932px] h-[430px]', // iPhone 16 Pro Max in landscape
}

export const iframeSizeIcons: Record<IframeSizes, React.ComponentType> = {
  [IframeSizes.Desktop]: DesktopIcon,
  [IframeSizes.SmallPhone]: IPhoneIcon,
  [IframeSizes.LargePhone]: IPadIcon,
  [IframeSizes.LandscapeSmallPhone]: IPhoneIconLandscape,
  [IframeSizes.LandscapeLargePhone]: IPadIconLandscape,
}
